import './SignOutLink.scss';

import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';

import {
  DestroySessionMutation,
  DestroySessionMutationVariables,
} from 'client/graphql/types/operations';

import * as state from 'state';

import {
  CURRENT_USER_QUERY,
  CurrentUserQuery,
} from 'queries/useCurrentUserQuery';

const DESTROY_SESSION_MUTATION = gql`
  mutation DestroySessionMutation($input: DestroySessionInput!) {
    destroySession(input: $input) {
      success
    }
  }
`;

interface Props {}

export const SignOutLink: FC<Props> = () => {
  const { t } = useTranslation();

  const [destroySession] = useMutation<
    DestroySessionMutation,
    DestroySessionMutationVariables
  >(DESTROY_SESSION_MUTATION, {
    update: (cache, result) => {
      if (result.data?.destroySession?.success) {
        cache.writeQuery<CurrentUserQuery>({
          query: CURRENT_USER_QUERY,
          data: { __typename: 'Query', currentUser: null },
        });
      }
    },
    onCompleted: (data) => {
      if (data?.destroySession?.success) {
        state.appendNotification({
          type: 'notice',
          content: t('sessions.signedOut'),
        });
      }
    },
  });

  return (
    <button
      className="SignOutLink"
      onClick={() => {
        destroySession({ variables: { input: {} } });
      }}
    >
      {t('sessions.signOut')}
    </button>
  );
};

export default SignOutLink;
